<div class="relative !flex justify-center">
    <p class="orb-app-light-dark:font-bold font-semibold dark:text-contrast-yellow">
        {{ 'CHANGE_LANGUAGE_TITLE' | translate }}
    </p>
    <button
        class="absolute right-4 text-grey-zambezy dark:text-contrast-yellow"
        [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
        (click)="closeDialog()"
        style="outline-style: none">
        <span class="icon icon-input-delete dark:filter-yellow"></span>
    </button>
</div>
<ul class="pl-3">
    <div
        class="radio flex h-14 items-center dark:text-contrast-yellow"
        *ngFor="let language of languages$ | async; index as i"
        attr.aria-label="{{ language.name + '. ' + ('DOUBLE_TAP_TO_ACTIVATE' | translate) }}">
        <input
            class="radio__radio"
            [id]="'lang' + i"
            [checked]="language.code === selectedLanguage?.code || language.code === (selectedLanguage$ | async)?.code"
            (click)="selectLanguage(language)"
            type="radio"
            name="selected-method" />
        <label
            class="radio__label"
            [for]="'lang' + i"
            (click)="selectLanguage(language)"
            (keydown.enter)="selectLanguage(language)"
            (keydown.space)="selectLanguage(language)">
            {{ language.name }}
        </label>
    </div>
</ul>
<button
    class="var-app-light:bg-secondary var-app-light:text-primary orb-app-light:bg-primary orb-app-light-dark:h-16 bg-secondary-button sr-app-light:text-white sr-app-light:h-16 my-4 h-12 w-full overflow-hidden rounded-lg font-bold dark:bg-contrast-yellow dark:text-contrast-black"
    (click)="onSubmit()">
    {{ 'CHANGE_LANGUAGE_CONFIRMATION' | translate }}
</button>
